<template>
  <a-modal
    v-model:visible="visible"
    title="分配负责人"
    :body-style="{ padding: '30px' }"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }">
      <a-form-item label="客户负责人" v-bind="validateInfos.seller">
        <UserSelect v-model:value="dataForm.seller" :status="1" placeholder="请选择" allowClear />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { publicCustomerAllot } from '@/api/gucangSales/customerCenter'
import type { SalesClueListItem } from '@/typings/api/clueManage'

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ seller: string; cosIdList: any[] }>({ seller: '', cosIdList: [] })
const formRules = reactive({
  follower: [{ required: true, message: '请选择客户负责人' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.cosIdList = selectedData.value.map((item: SalesClueListItem) => item.cosId)
    const params = Object.assign({}, dataForm)
    publicCustomerAllot(params)
      .then(() => {
        emit('fetch', dataForm.seller)
        DcMessage.success('分配客户负责人成功')
        resetFields()
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'CustomerAssign' }
</script>
<style scoped></style>
